import { JsonObject, JsonValue } from 'type-fest';

export function isNull(arg: unknown): arg is null {
  return arg === null;
}

export function isNotNull<T>(arg: T): arg is Exclude<T, null> {
  return arg !== null;
}

export function isUndefined(arg: unknown): arg is undefined {
  return typeof arg === 'undefined';
}

export function isNotUndefined<T>(arg: T): arg is Exclude<T, undefined> {
  return typeof arg !== 'undefined';
}

export function isTrue(arg: boolean): arg is true {
  return arg === true;
}

export function isFalse(arg: boolean): arg is false {
  return arg === false;
}

export function isStringArray(arg: unknown): arg is string[] {
  return Array.isArray(arg) && arg.every((item) => typeof item === 'string');
}

export function isValidNumber(arg: number | null | undefined): arg is number {
  return arg !== null && typeof arg !== 'undefined' && !isNaN(arg);
}

export function isJsonObject(arg: JsonValue): arg is JsonObject {
  return typeof arg === 'object' && arg !== null && !Array.isArray(arg);
}

export function isFileArray(arg: unknown): arg is File[] {
  return Array.isArray(arg) && arg.every((item) => item instanceof File);
}

export const isNonEmptyString = (value: unknown): value is string => {
  return typeof value === 'string' && value.length > 0;
};
